import { useLayoutEffect, useRef, useState } from 'react';

/** True when the element's layout width is at least `minWidthPx` (not the viewport). */
export function useElementMinWidth<T extends HTMLElement = HTMLDivElement>(minWidthPx: number) {
  const ref = useRef<T>(null);
  const [matches, setMatches] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const sync = () => setMatches(el.getBoundingClientRect().width >= minWidthPx);
    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    return () => observer.disconnect();
  }, [minWidthPx]);

  return [ref, matches] as const;
}
